import { Outlet } from "react-router-dom";
import { DeskSpendProvider } from "../context/DeskSpendContext";
import { DraftStateProvider } from "../context/DraftStateContext";
import { BudgetLockBanner } from "./BudgetLockBanner";
import { DeskSidebar } from "./DeskSidebar";

export function DeskLayout() {
  return (
    <DraftStateProvider>
    <DeskSpendProvider>
      <div className="flex h-screen overflow-hidden font-body-base text-body-base text-on-surface selection:bg-primary/30 print:h-auto print:overflow-visible print:block">
        <div className="print:hidden">
          <DeskSidebar />
        </div>
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden print:overflow-visible print:block">
          <div className="print:hidden">
            <BudgetLockBanner />
          </div>
          <Outlet />
        </div>
      </div>
    </DeskSpendProvider>
    </DraftStateProvider>
  );
}
